module.exports = __webpack_public_path__ + "assets/Retina-LightItalic.ed966bcfc94b3ae55d6c1b9b4d58401c.woff2";